<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../Cardwidgets.svelte";
  import { Project } from "../../../Data/Chart/Widget/ChartPage/Chart";
  import { chart } from "svelte-apexcharts";
    import { PROJECTS } from "../../../utils/Constant/Constant";
</script>

<Col xl="4">
  <Card
    cardprops="o-hidden"
    cardbodyprops="row"
    customCol="col-7"
    cardtitleprops="f-w-600 font-secondary"
    cardtitle={PROJECTS}
    cardvalue="30"
    customsubCol="col-5 text-end"
    cardsubvalue="12569"
  >
    <div id="chart-widget2" slot="customChart">
      <div class="flot-chart-placeholder" id="chart-widget-top-second">
        <div use:chart={Project} />
      </div>
    </div>
  </Card>
</Col>
